import styles from './SectionWrapper.module.css';

interface SectionWrapperProps {
  children: React.ReactNode;
  id?: string;
  className?: string;
  as?: 'section' | 'header' | 'footer';
}

export function SectionWrapper({ children, id, className = '', as: Tag = 'section' }: SectionWrapperProps) {
  return (
    <Tag id={id} className={`${styles.section} ${className}`}>
      <div className={styles.inner}>{children}</div>
    </Tag>
  );
}
